var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTmError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#678134;}\r\n\t.st2{fill:#1B7D9F;}\r\n\t.st3{fill:#934D4F;}\r\n\t.st4{fill:#FFFFFF;}\r\n\t.st5{fill:#8B7734;}\r\n\t.st6{fill:none;stroke:#678134;}\r\n\t.st7{fill:none;stroke:#934D4F;}\r\n\t.st8{fill:none;stroke:#4EA3C0;}\r\n\t.st9{fill:none;stroke:#8B7734;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 16,
    height: 16
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Color"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 8,
    cy: 11.72,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M8.9545,8.76V3.65c0-0.24-0.2-0.43-0.44-0.43h-1.029c-0.24,0-0.44,0.19-0.44,0.43v5.11 c0.01,0.24,0.2,0.44,0.44,0.44h1.029C8.7545,9.2,8.9545,9,8.9545,8.76z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "White"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55779_00000114769368258920015840000011217758876522069891_",
    className: "st4",
    d: "M8,16c-4.42,0-8-3.58-8-8 c0-4.42,3.58-8,8-8s8,3.58,8,8C15.99,12.42,12.42,15.99,8,16z M8.95,3.65c0-0.24-0.2-0.43-0.44-0.43H7.49 c-0.24,0-0.44,0.19-0.44,0.43v5.11C7.06,9,7.25,9.2,7.49,9.2h1.02c0.24,0,0.44-0.2,0.44-0.44V3.65z M8,10.52 c-0.66,0-1.2,0.53-1.2,1.2c0,0.66,0.54,1.2,1.2,1.2s1.2-0.54,1.2-1.2C9.2,11.05,8.66,10.52,8,10.52z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTmError);
export default __webpack_public_path__ + "static/media/TM__Error.07cfae7c8f7e5a90a033beb645437e9a.svg";
export { ForwardRef as ReactComponent };